// useRemoveUserFromCustomer.ts

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { removeUsersFromCustomer } from '../services/apiCustomers.ts';
import { toast } from '../utils/sweetAlert.ts';

export function useRemoveUserFromCustomer() {
  const queryClient = useQueryClient();

  const { mutate: removeUserFromCustomer, isPending: isRemoving } = useMutation({
    mutationFn: ({ customerId, userIds }: { customerId: number; userIds: string[] }) =>
      removeUsersFromCustomer(customerId, userIds),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users', 'customers'] });
      toast.success('User(s) removed from customer successfully!');
    },
    onError: (error: any) => {
      toast.error(`Something went wrong! ${error.message}`);
    },
  });

  return { isRemoving, removeUserFromCustomer };
}
